// if (!customElements.get('product-modal')) {
//   customElements.define(
//     'product-modal',
//     class ProductModal extends ModalDialog {
//       constructor() {
//         super();
//       }

//       hide() {
//         super.hide();
//       }

//       show(opener) {
//         super.show(opener);
//         this.showActiveMedia();
//       }

//       showActiveMedia() {
//         this.querySelectorAll(
//           `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
//         ).forEach((element) => {
//           element.classList.remove('active');
//         });
//         const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
//         const activeMediaTemplate = activeMedia.querySelector('template');
//         const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
//         activeMedia.classList.add('active');
//         activeMedia.scrollIntoView();

//         const container = this.querySelector('[role="document"]');
//         container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

//         if (
//           activeMedia.nodeName == 'DEFERRED-MEDIA' &&
//           activeMediaContent &&
//           activeMediaContent.querySelector('.js-youtube')
//         )
//           activeMedia.loadContent();
//       }
//     }
//   );
// }

// document.querySelectorAll('.product__modal-opener').forEach(function(button) {
//   button.addEventListener('click', function() {
//     document.querySelector('.product-media-modal').setAttribute('open', true);
//   });
// });

// document.querySelectorAll('.product__modal-opener').forEach(function(button, index) {
//   button.addEventListener('click', function() {
//     const modal = document.querySelector('.product-media-modal');
//     modal.setAttribute('open', true);

//     // Go to the clicked slide index in both sliders
//     $('.zoom-slider-wrapper').slick('slickGoTo', index);
//     $('.thumbnails-wrapper').slick('slickGoTo', index);

//     // Ensure layout renders correctly
//     $('.zoom-slider-wrapper, .thumbnails-wrapper').slick('setPosition');
//   });
// });
// document.querySelectorAll('.product-media-modal__toggle').forEach(function(button) {
//   button.addEventListener('click', function() {
//     document.querySelector('.product-media-modal').removeAttribute('open');
//   });
// });


document.querySelectorAll('.product__modal-opener').forEach(function(button, index) {
  button.addEventListener('click', function() {
    const modal = document.querySelector('.product-media-modal');
    modal.setAttribute('open', true);
    document.body.classList.add('pdp-modal-preview');

    // Go to the clicked slide index in both sliders
    $('.zoom-slider-wrapper').slick('slickGoTo', index);
    $('.thumbnails-wrapper').slick('slickGoTo', index);

    // Ensure layout renders correctly
    $('.zoom-slider-wrapper, .thumbnails-wrapper').slick('setPosition');
  });
});
document.querySelectorAll('.product-media-modal__toggle').forEach(function(button) {
  button.addEventListener('click', function() {
    document.querySelector('.product-media-modal').removeAttribute('open');
    document.body.classList.remove('pdp-modal-preview');
  });
});
// Optional safety check (agar attribute manually change ho)
const modal = document.querySelector('.product-media-modal');
const observer = new MutationObserver(() => {
  if (modal.hasAttribute('open')) {
    document.body.classList.add('pdp-modal-preview');
  } else {
    document.body.classList.remove('pdp-modal-preview');
  }
});
observer.observe(modal, { attributes: true });




document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("[id^='ZoomSliderWrapper-']").forEach(function (wrapper) {
    if (!wrapper || !window.jQuery) return;

    const sectionId = wrapper.id.replace("ZoomSliderWrapper-", "");
    const $wrapper = jQuery(wrapper);
    const currentEl = document.getElementById(`currentSlide-${sectionId}`);
    const totalEl = document.getElementById(`totalSlides-${sectionId}`);

    if (!currentEl || !totalEl) return;

    // When slick initializes
    $wrapper.on("init", function (event, slick) {
      totalEl.textContent = slick.slideCount;
      currentEl.textContent = slick.currentSlide + 1;
    });

    // When slide changes (next/prev/swipe)
    $wrapper.on("afterChange", function (event, slick, currentSlide) {
      currentEl.textContent = currentSlide + 1;
    });

    // Handle case if Slick already initialized before script loads
    if ($wrapper.hasClass("slick-initialized")) {
      const slick = $wrapper.slick("getSlick");
      totalEl.textContent = slick.slideCount;
      currentEl.textContent = slick.currentSlide + 1;
    }
  });
});
